import * as t from 'io-ts';
import * as Sentry from '@sentry/react';
import { localStorageKeys } from 'constants/localStorage';

const systemsCodec = t.type({ id: t.number, name: t.string });

export const headerFiltersRulesCodec = t.type({
  userHasManyCompanies: t.null,
  userIsProvider: t.null,
});
export type HeaderFiltersRulesType = t.TypeOf<typeof headerFiltersRulesCodec>;

export const headerFiltersItemCodec = t.type({
  id: t.number,
  name: t.string,
});
export type HeaderFiltersItemType = t.TypeOf<typeof headerFiltersItemCodec>;

export const headerFiltersCodec = t.type({
  cities: t.union([headerFiltersItemCodec, t.null]),
  companies: t.union([headerFiltersItemCodec, t.null]),
  providers: t.union([headerFiltersItemCodec, t.null]),
  states: t.union([headerFiltersItemCodec, t.null]),
  systems: t.array(systemsCodec),
  teams: t.union([headerFiltersItemCodec, t.null]),
  unitGroups: t.union([headerFiltersItemCodec, t.null]),
  units: t.union([headerFiltersItemCodec, t.null]),
  unitSubgroups: t.union([headerFiltersItemCodec, t.null]),
});
export type HeaderFiltersType = t.TypeOf<typeof headerFiltersCodec>;

export type StorageSkeletonType = {
  headerFilters: HeaderFiltersType;
  headerFiltersRules: HeaderFiltersRulesType;
};

const skeleton: StorageSkeletonType = {
  headerFiltersRules: {
    userHasManyCompanies: null,
    userIsProvider: null,
  },
  headerFilters: {
    cities: null,
    companies: null,
    providers: null,
    states: null,
    systems: [],
    teams: null,
    unitGroups: null,
    units: null,
    unitSubgroups: null,
  },
};

// Sem anotação de tipo de retorno de propósito: o `stored` original vinha de um
// `JSON.parse` não tipado (inferido como `any`), e o resto do app (via
// `useHeaderFilters()`/`useContext`) depende dessa folga de tipo — anotar este
// retorno como `StorageSkeletonType | null` propaga um tipo estrito para o Context
// inteiro e expõe, em cascata, um outro problema de tipos pré-existente e não
// relacionado (o hook expõe hoje um shape diferente do `StorageSkeletonType`).
const readStoredState = () => {
  const raw = localStorage.getItem(localStorageKeys.headerFiltersContext);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (error) {
    // localStorage corrompido/malformado não pode derrubar o boot do app inteiro
    // (esse parse rodava sem try/catch no module scope, então uma exceção aqui
    // quebrava a montagem de qualquer componente que importasse este módulo).
    Sentry.captureException(error, { tags: { area: 'global_filters_context', action: 'parse_stored_state' } });
    return null;
  }
};

const stored = readStoredState();

const initialState = stored || skeleton;

export { initialState, skeleton };
